import axios from 'axios';
import { useError } from '../contexts/ErrorContext';

const instance = axios.create({
  // Use nullish coalescing — `||` would coerce an explicit empty-string env var
  // (the way production .env disables the absolute base URL) back to a localhost
  // default, which broke prod logins. Treat missing/unset as empty so the bundle
  // makes relative /api calls and stays on the page's own origin.
  baseURL: `${process.env.REACT_APP_API_BASE_URL ?? ''}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // Important for cookies
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response?.status === 401) {
      // Redirect to login if not already there, but exclude public routes
      const publicRoutes = ['/login', '/re/register', '/re/payment', '/ocia/register', '/ocia/payment'];
      // Campus Ministry forms live at /campus-ministry/<form>/register|payment.
      const isCampusMinistryPublic = /^\/campus-ministry\/[a-z0-9-]+\/(register|payment)$/.test(window.location.pathname);
      if (!publicRoutes.includes(window.location.pathname) && !isCampusMinistryPublic) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default instance; 